import React, { useEffect } from "react";
import { Meter } from "./Dialog/Meter";
import { Button } from "../../../../button";
import { FormattedMessage } from "react-intl";
import { getLoveMeterValue } from "../../../../../clients/poll";
import { usePollContext } from "../../../../../stores/poll";
import { bridge } from "../../../../../utils/bridge";

export function DayTransition({
    pollId,
    dateNumber,
}: {
    pollId?: string;
    dateNumber: string;
}) {
    const [loveMeterValue, setLoveMeterValue] = React.useState<number>(0);
    const [visible, setVisible] = React.useState<boolean>(
        localStorage.getItem(
            `velvet-glitch-day-transition-${dateNumber}-seen`,
        ) !== "true",
    );
    const [animatedHide, setAnimatedHide] = React.useState<boolean>(false);
    const pollContext = usePollContext();

    const PPXP = "71f2b89d-d4da-4c80-9d85-e49a910c2f25";

    const {
        isClosed,
        actions: { refreshPollInfo },
    } = pollContext;
    useEffect(() => {
        refreshPollInfo(pollId || "");
    }, [pollId]);

    // Fetch love meter value when poll becomes available
    React.useEffect(() => {
        if (!pollId) {
            return;
        }

        getLoveMeterValue(pollId).then((value) => {
            if (value !== null) {
                setLoveMeterValue(value);
            }
        });
    }, [pollId]);

    if (!visible) {
        return null;
    }

    return (
        <div
            className={`day-transition date${dateNumber} ${animatedHide ? "hide" : ""}`}
        >
            <div className="final-question-text">
                <div className="text">
                    <FormattedMessage id="globalText.langVelvetGlitchFinalQuestion" />
                </div>
            </div>
            <Meter
                oldValue={0}
                newValue={loveMeterValue}
                animationDuration={3000}
                dividers={[33, 66]}
                finished={isClosed(pollId || "")}
            />
            <div className="button-wrapper">
                <Button
                    size="sm"
                    variant="pink"
                    onClick={async () => {
                        if (dateNumber === "5") {
                            setAnimatedHide(true);
                            setVisible(false);
                            localStorage.setItem(
                                `velvet-glitch-day-transition-${dateNumber}-seen`,
                                "true",
                            );

                            const b = await bridge();
                            b.claimVoucherQuiet(PPXP);
                            b.close();
                            return;
                        }

                        setAnimatedHide(true);

                        setTimeout(() => {
                            setVisible(false);
                            localStorage.setItem(
                                `velvet-glitch-day-transition-${dateNumber}-seen`,
                                "true",
                            );
                        }, 300);
                    }}
                >
                    <span className="buttonTextWrapper">
                        {dateNumber === "5" ? (
                            <FormattedMessage id="globalText.langClaim" />
                        ) : (
                            <FormattedMessage id="globalText.langVelvetGlitchContinue" />
                        )}
                    </span>
                </Button>
            </div>
        </div>
    );
}
